import getSelectedFolder from './getSelectedFolder';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export default function getSelectedFolderMailboxInfoOrDefault(): any {
    return getSelectedFolder()?.mailboxInfo || getGlobalSettingsAccountMailboxInfo();
}
